export default function SelectedTag({ interviewTag }) {
  function calculate(color) {
    let hex = color.substring(1);
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    let yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? "black" : "white";
  }

  return (
    <>
      <div className="d-flex">
        {interviewTag &&
          interviewTag.map((tag) => (
            <span
              key={tag.id}
              className="badge m-1  fs-5"
              style={{
                color: calculate(tag.color),
                backgroundColor: tag.color
              }}
            >
              {tag.name}
            </span>
          ))}
      </div>
    </>
  );
}
